exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".itb-custom-btn[data-v-bdcbe530]{background:#1976d2;border-radius:4px;padding:4px 8px;border:none;cursor:pointer;font-weight:700;margin-right:4px}.itb-custom-btn[data-v-bdcbe530],.itb-custom-btn i[data-v-bdcbe530]{color:#fff!important}.itb-custom-btn[data-v-bdcbe530]:hover{background:#1565c0}", ""]);

// exports
